import Vue from "vue";

Vue.component("publication-media-list", {
	props: ["partyId", "hasPartyFilter"],
	data() {
		return {
            selectedTab: 0
		};
    },
    computed: {
        appendix2Label: function () {
            return window.labels.appendix2Display;
        },
        appendix3Label: function () {
            return window.labels.appendix3Display;
        },
        appendix4Label: function () {
            return window.labels.appendix4Display;
        },
        appendix2Tooltip: function () {
            return window.labels.appendix2Tooltip;
        },
        appendix3Tooltip: function () {
            return window.labels.appendix3Tooltip;
        },
        appendix4Tooltip: function () {
            return window.labels.appendix4Tooltip;
        },
        appendix2: function () {
            return window.labels.appendix2;
        },
        appendix3: function () {
            return window.labels.appendix3;
        },
        appendix4: function () {
            return window.labels.appendix4;
        },
        appendix2Name: function () {
            return window.labels.appendix2Name;
        },
        appendix3Name: function () {
            return window.labels.appendix3Name;
        },
        appendix4Name: function () {
            return window.labels.appendix4Name;
        },
        appendixILink: function () {
            return `https://wto.org/${window.urls.currentLanguageForWTOWebsiteLink}/tratop_${window.urls.currentLanguageInitialForWTOWebsiteLink}/gproc_${window.urls.currentLanguageInitialForWTOWebsiteLink}/rev_apii_${window.urls.currentLanguageInitialForWTOWebsiteLink}.pdf`;
        },
        appendixIILink: function () {
            return `https://wto.org/${window.urls.currentLanguageForWTOWebsiteLink}/tratop_${window.urls.currentLanguageInitialForWTOWebsiteLink}/gproc_${window.urls.currentLanguageInitialForWTOWebsiteLink}/rev_apiii_${window.urls.currentLanguageInitialForWTOWebsiteLink}.pdf`;
        },
        appendixIVLink: function () {
            return `https://wto.org/${window.urls.currentLanguageForWTOWebsiteLink}/tratop_${window.urls.currentLanguageInitialForWTOWebsiteLink}/gproc_${window.urls.currentLanguageInitialForWTOWebsiteLink}/rev_apiv_${window.urls.currentLanguageInitialForWTOWebsiteLink}.pdf`;
        }
    },
	template: `
		<div>
			<b-tabs expanded v-model="selectedTab">
                <b-tab-item value="0" style="padding-left: 0px !important; padding-right: 0px !important;">
                    <template #header>
                        <img src="/images/laws_regulations.png" width="60" height="60" />
                        <span>{{appendix2Label}}</span>
                    </template>
                    <section class="card">
                        <header class="card-header">
                            <div class="card-header-title">
                                <div class="column is-11">{{appendix2Name}}</div>
                                <div class="column is-1 has-text-centered">
                                    <a :href="appendixILink" target="_blank">
                                        <b-tooltip type="is-success"
                                                    :label="appendix2Tooltip"
                                                    position="is-left"
                                                    multilined>
                                            <i class="far fa-file-pdf has-text-danger fa-2x"></i><br />
                                            <span class="publication-media-appendix-label">{{appendix2}}</span>
                                        </b-tooltip>
                                    </a>
                                </div>
                            </div>
                        </header>
                        <div class="card-content">
                            <div class="content">
                                <publication-media appendix-number="2" :use-tree-view="false" :allow-searching="true" :has-party-filter="hasPartyFilter" :party-id="partyId"></publication-media>
                            </div>
                        </div>
                    </section>
                </b-tab-item>
                <b-tab-item value="1" style="padding-left: 0px !important; padding-right: 0px !important;">
                    <template #header>
                        <img src="/images/procurement_notices.png" width="60" height="60" />
                        <span>{{appendix3Label}}</span>
                    </template>
                    <section class="card">
                        <header class="card-header">
                            <div class="card-header-title">
                                <div class="column is-10">{{appendix3Name}}</div>
                                <div class="column is-2 has-text-centered">
                                    <a :href="appendixIILink" target="_blank">
                                        <b-tooltip type="is-success"
                                                    :label="appendix3Tooltip"
                                                    position="is-left"
                                                    multilined>
                                            <i class="far fa-file-pdf has-text-danger fa-2x"></i><br />
                                            <span class="publication-media-appendix-label">{{appendix3}}</span>
                                        </b-tooltip>
                                    </a>
                                </div>
                            </div>
                        </header>
                        <div class="card-content">
                            <div class="content">
                                <publication-media appendix-number="3" :use-tree-view="false" :allow-searching="true" :has-party-filter="hasPartyFilter" :party-id="partyId"></publication-media>
                            </div>
                        </div>
                    </section>
                </b-tab-item>
                <b-tab-item value="2" style="padding-left: 0px !important; padding-right: 0px !important;">
                    <template #header>
                        <img src="/images/statistics.png" width="60" height="60" />
                        <span>{{appendix4Label}}</span>
                    </template>
                    <section class="card">
                        <header class="card-header">
                            <div class="card-header-title">
                                <div class="column is-10">{{appendix4Name}}</div>
                                <div class="column is-2 has-text-centered">
                                    <a :href="appendixIVLink" target="_blank">
                                        <b-tooltip type="is-success"
                                                    :label="appendix4Tooltip"
                                                    position="is-left"
                                                    multilined>
                                            <i class="far fa-file-pdf has-text-danger fa-2x"></i><br />
                                            <span class="publication-media-appendix-label">{{appendix4}}</span>
                                        </b-tooltip>
                                    </a>
                                </div>
                            </div>
                        </header>
                        <div class="card-content">
                            <div class="content">
                                <publication-media appendix-number="4" :use-tree-view="false" :allow-searching="true" :has-party-filter="hasPartyFilter" :party-id="partyId"></publication-media>
                            </div>
                        </div>
                    </section>
                </b-tab-item>
            </b-tabs>
		</div>
	`
});